<template>
	<div class="users">
		<breadcrumb :items="[{ text: 'Usuários', active: true }]" />
		
		<router-link class="btn btn-primary btn-add " to="/cadastrar-usuario"><i class="fa fa-plus"></i> Cadastrar usuário</router-link>
		<div class="initialize-chat">
			<button v-if="isSeller" class="btn btn-primary btn-sm" @click="initializeMatrixChat">Ativar chat para todos usuarios</button>
		</div>

		<input v-model="filters.search" class="form-control mb-2" placeholder="Buscar...">
		<b-alert variant="danger" show v-if="error">{{error}}</b-alert>
		<loading :loading="!users && !error" msg="Carregando lista de usuarios" />
		<no-item :list="users" />
		<div v-if="users && users.length">
			<b-table stacked="lg" :fields="table_fields" :items="users" :sort-by="'name'" :filter="filters.search">
				<template slot="name" slot-scope="data">
					<router-link :to="'/editar-usuario/'+ data.item._id">
						{{data.item.name}}
						<small><br>{{data.item.email}}</small>
					</router-link>
				</template>
				<template slot="roles" slot-scope="data">
					{{data.value | roles}}
					<small v-if="data.value && data.value[0] == 'manager' && data.item.organization"><br>{{data.item.organization.name}}</small>
					<small v-if="data.value && data.value[0] == 'supplier' && data.item.supplier"><br>{{data.item.supplier.name}}</small>
				</template>
				<template slot="actions" slot-scope="data">
					<div class="btn-group btn-group-sm">
						<button v-if="data.item.matrixLogin" class="btn btn-primary" @click="startChat(data.item._id)"> <i class="fa fa-commenting-o"></i></button>
						<button v-else-if="isSeller" class="btn btn-primary btn-sm" @click="initializeChatForUser(data.item._id)">Ativar chat</button>

						<router-link class="btn btn-primary" :to="'/editar-usuario/'+ data.item._id">
							<i class="fa fa-pencil"></i>
						</router-link>
						<button v-if="isSupplier" class="btn btn-secondary" @click="remove(data.item._id)"> <i class="fa fa-close"></i> </button>
					</div>
				</template>
			</b-table>
		</div>
	</div>
</template>
<script>
import axios from 'axios'
import Loading from '@/components/Loading'
import NoItem from '@/components/NoItem'

export default {

	name: 'Users',

	data () {
		return {

			filters: { search: null },
			table_fields: [
				{ key: 'name', label: 'Nome', sortable: true },
				{ key: 'roles', label: 'Perfis', sortable: true },
				{ key: 'actions', label: 'Ações', 'class': 'td-actions' },
			],
			users: null
		}
	},
	created () {
		this.list()
	},
	methods: {
		list () {
			axios.get('users', {
				params: {
					populate: 'organization supplier'
				}
			}).then(response => {
				this.users = response.data
			}).catch(this.showError)
		},
		startChat(id){
			this.$store.dispatch('startChatWith',id)
		},
		initializeMatrixChat() {
      		axios
        	.post("users/createMatrixUser")
        	.then((response) => {
        	  if (response.data) {
			  	console.log('[MATRIX USER CREATION RESULT]:',response.data);
				this.notify(`Chat ativado para ${response.data.createdUsers.length} novos usuários. `);
				this.list()
      	    }
        })
        .catch(this.showError);
	},
	initializeChatForUser(userId){
		axios
        	.post(`users/${userId}/createMatrixUser`)
        	.then((response) => {
        	  if (response.data) {
				console.log('[MATRIX USER CREATION RESULT]:',response.data);
				this.notify("Chat ativado com sucesso.");
				this.list()
      	    }
        })
        .catch(this.showError);
	},
		remove (id) {
			if (confirm("Tem certeza que deseja excluír?")) {
				axios.delete('users/' + id).then(() => {
					this.list()
				}).catch(this.showError)
			}
		}
	},
	components: {
		Loading,
		NoItem,
	}

};
</script>
<style>
.initialize-chat {
	display: flex;
	justify-content: flex-end;
	width: 100%;
	padding-bottom: 20px;

}
</style>
